
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// composable
import { DataState } from '@/core/classes/DataState.class'

// types
import { CityT } from '@/core/types/cities.types'

// constants
import { FLIGHT_DEPARTURES_STATUSES } from '@/core/constants/flight_departures.constants'

// realisations
import { cities } from '@/core/realisations/cities.realisation'

export default defineComponent({
    components: {
        TheInput,
        TheSelect,
        TheButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reset', 'search'],
    setup(props, { emit }) {
        const state = reactive({
            departureAtFrom: null as string | null,
            departureAtTo: null as string | null,
            arrivalAtFrom: null as string | null,
            arrivalAtTo: null as string | null,
            cityIdFrom: null as number | null,
            cityIdTo: null as number | null,
            status: null as number | null,
            number: null as string | null,
        })

        const data_state = reactive({
            cities: new DataState<CityT>({}),
        })

        const reset = () => {
            if (props.loading) return

            state.departureAtFrom = null
            state.departureAtTo = null
            state.arrivalAtFrom = null
            state.arrivalAtTo = null
            state.cityIdFrom = null
            state.cityIdTo = null
            state.status = null
            state.number = null

            emit('reset')
        }

        const search = () => {
            if (props.loading) return

            emit('search', { ...state })
        }

        // CITIES

        const loadCities = async (page: number, search?: string) => {
            data_state.cities.pagination.current_page = page

            try {
                data_state.cities.is_loading = true

                const data = await cities.getAllList(page, search)
                data_state.cities.list = data.data

                data_state.cities.pagination.total_pages = data.meta.last_page

                data_state.cities.is_failed = false
                data_state.cities.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.cities.failure.catchError(error)

                if (!data_state.cities.failure.error_state.is_cancel) {
                    data_state.cities.is_failed = true
                }
            } finally {
                if (!data_state.cities.failure.error_state.is_cancel) {
                    data_state.cities.is_loading = false
                }
            }
        }

        const loadMoreCities = async (page: number) => {
            if (page > data_state.cities.pagination.total_pages) return
            data_state.cities.pagination.current_page = page

            try {
                data_state.cities.is_loading = true

                const response = await cities.getAllList(page)
                data_state.cities.list = data_state.cities.list.concat(response.data)

                data_state.cities.pagination.total_pages = response.meta.last_page

                data_state.cities.is_failed = false
                data_state.cities.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.cities.failure.catchError(error)

                if (!data_state.cities.failure.error_state.is_cancel) {
                    data_state.cities.is_failed = true
                }
            } finally {
                if (!data_state.cities.failure.error_state.is_cancel) {
                    data_state.cities.is_loading = false
                }
            }
        }

        const searchCity = (search_query: string) => {
            // data_state.cities.pagination.current_page
            loadCities(1, search_query)
        }

        const unshiftFindedCity = async (city: CityT) => {
            await loadCities(data_state.cities.pagination.current_page)
            data_state.cities.list.unshift(city)
        }

        //

        onBeforeMount(() => {
            loadCities(1)
        })

        return {
            state,
            data_state,
            reset,
            search,
            FLIGHT_DEPARTURES_STATUSES,
            // cities
            loadCities,
            loadMoreCities,
            searchCity,
            unshiftFindedCity,
        }
    },
})
